import React from "react";
import "./Info.scss";

const formatDisplayDate = (value) => {
  if (!value) {
    return "";
  }

  return new Date(value).toLocaleDateString("en-US");
};

const Info = (props) => {
  const dateRange =
    props.startDate && props.endDate
      ? `${formatDisplayDate(props.startDate)} – ${formatDisplayDate(props.endDate)}`
      : "";

  return (
    <div className="info_Details">
      <img
        src={props.icon}
        alt="..."
        className="certificate_Img"
        width="50%"
      />
      <div className="name">{props.name}</div>
      <div className="program">{props.program}</div>
      {dateRange ? <div className="program">{dateRange}</div> : null}
    </div>
  );
};

export default Info;
